export const THIS_COMPUTER_VIEWER_ONLY_PREFIX =
  "nlkb.this-computer-viewer-only.";

export function thisComputerViewerOnlyQueryKey(
  organizationId: string,
  principalId: string,
): readonly ["this-computer-viewer-only", string, string] {
  return ["this-computer-viewer-only", organizationId, principalId];
}

export function thisComputerViewerOnlyStorageKey(
  organizationId: string,
  principalId: string,
): string {
  return `${THIS_COMPUTER_VIEWER_ONLY_PREFIX}${organizationId}.${principalId}`;
}

export function shouldShowThisComputerPlaceholder(input: {
  readonly desktopRuntime: boolean;
  readonly enrolled: boolean;
  readonly viewerOnly: boolean;
}): boolean {
  return input.desktopRuntime && !input.enrolled && !input.viewerOnly;
}

export function shouldShowConnectionsEmptyState(input: {
  readonly pairedCount: number;
  readonly showingThisComputerPlaceholder: boolean;
}): boolean {
  return input.pairedCount === 0 && !input.showingThisComputerPlaceholder;
}

export function isAdoptedReplicaConnection(
  connectionId: string,
  enrolled: boolean,
  replicaConnectionId: string | null | undefined,
): boolean {
  if (!enrolled) return false;
  const adopted = replicaConnectionId?.trim() ?? "";
  return adopted.length > 0 && adopted === connectionId;
}

export function readThisComputerViewerOnly(
  organizationId: string,
  principalId: string,
): boolean {
  try {
    return (
      window.localStorage.getItem(
        thisComputerViewerOnlyStorageKey(organizationId, principalId),
      ) === "1"
    );
  } catch {
    return false;
  }
}

export function persistThisComputerViewerOnly(
  organizationId: string,
  principalId: string,
): void {
  try {
    window.localStorage.setItem(
      thisComputerViewerOnlyStorageKey(organizationId, principalId),
      "1",
    );
  } catch {
    // Ignore quota and private-mode failures.
  }
}
